import styled from '@emotion/styled';

export const StyledContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  width: '100%',
});
